<script lang="ts" setup>
  import { EditorPageHeader } from '@/shared/ui/components'
  import PageDecorationImage from '@/shared/ui/components/PageDecorationImage.vue'

  import { FaqEditor } from '@/features/faq'

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('faq_create_page_title'),
  })
</script>

<template>
  <div class="relative flex w-full max-w-250 flex-col">
    <PageDecorationImage class="pointer-events-none absolute top-0 right-0" />
    <EditorPageHeader
      parent-route-name="/faq/"
      parent-label-key="navigation_item_faq"
      :current-label="$t('faq_breadcrumb_add')"
      data-testid="faq-editor-page-header"
    />
    <FaqEditor />
  </div>
</template>
